import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetCociDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_COCI_DETAILS, token);
  return res;
};

export const GetCoci = async (cociId) => {
  const token = localStorage.getItem("token");
  const params = { cociId };
  let res = await Services.GET(Url.GET_COCI, token);
  return res;
};

export const AddCoci = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_COCI, payload, token);
  return res;
};

export const DeleteCoci = async (cociId) => {
  const token = localStorage.getItem("token");
  const params = { cociId };
  let res = await Services.DELETE(Url.DELETE_COCI+cociId, params, token);
  return res;
};

export const UpdateCoci = async (cociId, payload) => {
  const token = localStorage.getItem("token");
  const params = { cociId };
  let res = await Services.POST(Url.UPDATE_COCI + cociId, payload, token);
  return res;
};
